var _circle, _circle2, _g, _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _circle3, _circle4, _circle5, _circle6, _line, _circle7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRobotSad(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 285,
    viewBox: "0 0 276 285",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 146,
    r: 138,
    fill: "#F7F8F8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1616_7619",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 9,
    width: 276,
    height: 276
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 147,
    r: 138,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1616_7619)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 138,
    cy: 330.5,
    rx: 104,
    ry: 121.5,
    fill: "#4BC3B5"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 121,
    width: 216,
    height: 56,
    rx: 5,
    fill: "#4BC3B5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 110,
    width: 199,
    height: 79,
    rx: 5,
    fill: "#48BAAD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 104,
    width: 173,
    height: 90,
    rx: 5,
    fill: "#4BC3B5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53 96.2796C53 90.6025 56.9978 85.6868 62.5666 84.5836C120.286 73.1486 154.962 73.1388 211.485 84.554C217.031 85.674 221 90.5788 221 96.2362V203.264C221 208.953 217.02 213.836 211.408 214.763C197.216 217.106 168.847 221 137 221C105.153 221 76.7839 217.106 62.5924 214.763C56.9797 213.836 53 208.953 53 203.264V96.2796Z",
    fill: "#48BAAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67 112.773C67 106.979 71.1429 102 76.8541 101.027C123.989 93 153.028 92.991 199.193 101C204.884 101.987 209 106.958 209 112.734V186.003C209 191.789 204.883 196.727 199.156 197.544C186.678 199.326 163.676 202 138 202C112.324 202 89.3223 199.326 76.8441 197.544C71.1171 196.727 67 191.789 67 186.003V112.773Z",
    fill: "#4BC3B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70 114.992C70 109.19 74.1489 104.206 79.8709 103.246C124.611 95.7388 152.351 95.7296 196.171 103.219C201.873 104.193 206 109.169 206 114.954V183.717C206 189.472 201.917 194.394 196.224 195.232C184.196 197.002 162.355 199.609 138 199.609C113.645 199.609 91.8037 197.002 79.7762 195.232C74.0829 194.394 70 189.472 70 183.717V114.992Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128 177H148C148 171.477 143.523 167 138 167C132.477 167 128 171.477 128 177Z",
    fill: "#373838"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 149,
    r: 9,
    fill: "#373838"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5,
    cy: 150.5,
    r: 2.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 149,
    r: 9,
    fill: "#373838"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 175.5,
    cy: 150.5,
    r: 2.5,
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 38,
    y1: 9,
    x2: 38,
    y2: 127,
    stroke: "#4BC3B5",
    strokeWidth: 2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 5,
    r: 5,
    fill: "#4BC3B5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotSad);
export default __webpack_public_path__ + "static/media/robotSad.5475b2e75e7dd8cd0a7df7b43778ca0d.svg";
export { ForwardRef as ReactComponent };